import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'react-responsive-modal'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { getPackageCategories, getPackageCategoriesLoading } from '../../selectors'
import { AdditionalPreloader } from 'src/ui/Preloader'

export const PackageCategories = ({ packageCategories, isPackageCategoriesLoading, page }) => {
  const { t } = useTranslation('common')

  if (page === 'profile') {
    return !isPackageCategoriesLoading ? <table className='tabela-izabrano' style={{ width: '100%' }}>
      <tbody>
        <tr>
          <th>{t('Kategorija')}</th>
          <th>{t('packages_categoryLimit_text')}</th>
        </tr>

        {packageCategories.map(packageCategory => (
          <tr key={`packageCategory-${packageCategory.category.id}`}>
            <td>{packageCategory.category.title}</td>
            <td>{packageCategory.adLimit}</td>
          </tr>
        )
        )}
      </tbody>
    </table> : <AdditionalPreloader />
  }

  return null
}

const mapStateToProps = state => ({
  packageCategories: getPackageCategories(state),
  isPackageCategoriesLoading: getPackageCategoriesLoading(state)
})

PackageCategories.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  packageCategories: PropTypes.array.isRequired,
  isPackageCategoriesLoading: PropTypes.bool.isRequired
}

export default connect(mapStateToProps)(PackageCategories)
